<div class="modal" tabindex="-1" role="dialog" id="modPassword" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body"><span class="text-success text-center fs-3 font-weight-bold">{{this.message}}</span></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="onConnect()">Fermer</button>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid d-flex flex-column justify-content-center align-items-center vh-100">

  <div class="row g-3  login-home " id="changePassword" >
    @if(isVersusPay){
      <div class="ms-3">
        <img src="images/versus-white.png" class="img-fluid col-2 mb-3">
      </div>

      <div class="col-sm-4">
        <h2 class=" text-white mb-4">{{messageType}}</h2>
      </div>
    }

    <div [ngClass]="isVersusPay? 'col-sm-5 justify-content-center' :'col-sm-5'">
      @if(!isVersusPay){
        <div class="row justify-content-center">
          <img src="brand/logo.jpeg" class="mt-2 col-3 img-fluid  mb-3" style="height: 150px;" >
        </div>
      }

      @if (isChangePasswd) {
        <form (ngSubmit)="onChangePasswd()" [formGroup]="changeForm">
          <div class="form-group">
            @if (message.length>0) {
              <p class="text-danger">{{message}}</p>
            }
          </div>
          <div class="form-group input-group">
            <div class="form-floating">
              <input type="password" class="ms-2 mr-2 mt-2 form-control" id="oldPassword" formControlName="oldPassword"
                placeholder="Ancien mot de passe">
              <label for="oldPassword">Ancien mot de passe</label>
            </div>
            <span class="input-group-text" id="eye" (click)="onShowOldPassword()">
              @if (!clearPassword) {
                <i class="fa fa-eye-slash"></i>
              }
              @if (clearPassword) {
                <i class="fa fa-eye"></i>
              }
            </span>
          </div>
          <div class="input-group">
            <div class="form-floating">
              <input type="password" class="ms-2  mt-2 form-control" id="newPassword" formControlName="newPassword"
                placeholder="Nouveau mot de passe">
              <label for="newPassword">Nouveau mot de passe</label>
            </div>
            <span class="input-group-text" id="eye" (click)="onShowNewPassword()">
              @if (!clearNewPassword) {
                <i class="fa fa-eye-slash"></i>
              }
              @if (clearNewPassword) {
                <i class="fa fa-eye"></i>
              }
            </span>
          </div>
          <div class="form-group  input-group form-floating">
            <div class="form-floating">
              <input type="password" class="ms-2 mt-2 form-control" id="confPassword" formControlName="confPassword"
                placeholder="Confirmer le nouveau mot de password" (change)="checkConfPassword()">
              <label for="confPassword">Confirmer le nouveau mot de password</label>
            </div>
            <span class="input-group-text" id="eye" (click)="onShowNewPassword()">
              @if (!clearNewPassword) {
                <i class="fa fa-eye-slash"></i>
              }
              @if (clearNewPassword) {
                <i class="fa fa-eye"></i>
              }
            </span>
          </div>
          <input type="hidden" name="confirmCheck" id="confirmCheck" formControlName="confirmCheck" />
          <div class="row justify-content-center">
            <button type="submit" class="col-sm-4 btn btn-success btn-block mt-3 ms-3"
            [disabled]="!this.changeForm.valid">Valider</button>
          </div>
        </form>
      }

      @if (!isChangePasswd) {
        <form   id="resetPassword" (ngSubmit)="onResetPasswd()"
          [formGroup]="resetForm">
          <h2 class="mb-4" [ngClass]="isVersusPay?'text-black':'text-white'">Réinitialiser votre mot de passe</h2>
          <div class="form-group">
            @if (message.length>0) {
              <p class="text-danger">{{message}}</p>
            }
          </div>
          <div class="form-group form-floating">
            <input type="username" class="ms-2 mr-2 mt-2 form-control" id="username" formControlName="username"
              placeholder="Entrer votre identifiant">
            <label for="username">Entrer votre identifiant</label>
          </div>
          <button type="submit" class="btn btn-success btn-block mt-3 ms-4"
          [disabled]="!this.resetForm.valid">R&#233;nitialiser</button>
        </form>
      }

    </div>
  </div>
</div>